import styled from "@emotion/styled";
import { SvgIcon } from "@mui/material";
import { black } from "../../designSystem/theme";
import IconProps from "./IconProps";

const Root = styled(SvgIcon)({ width: 24, height: 24 });

export default function CalendarIcon({ fill = black, className }: IconProps) {
  return (
    <Root viewBox="0 0 24 24" classes={{ root: className }}>
      <path
        d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"
        fill={fill}
      />
    </Root>
  );
}
